// Language-independent assets & mock account data

export const IMG = {
  hero: "https://images.unsplash.com/photo-1714974528703-e5ad41abc259",
  network: "https://images.unsplash.com/photo-1714974528737-3e6c7e4d11af",
  wealth: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d",
  advisory: "https://images.unsplash.com/photo-1562564055-71e051d33c19",
  team: [
    "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
};

export const FLAGS = [
  { code: "de", name: "Deutschland" }, { code: "fr", name: "France" }, { code: "es", name: "España" },
  { code: "it", name: "Italia" }, { code: "nl", name: "Nederland" }, { code: "be", name: "België" },
  { code: "at", name: "Österreich" }, { code: "lu", name: "Luxembourg" }, { code: "ie", name: "Ireland" },
  { code: "pt", name: "Portugal" }, { code: "se", name: "Sverige" }, { code: "dk", name: "Danmark" },
  { code: "fi", name: "Suomi" }, { code: "gb", name: "United Kingdom" },
];

// Demo account (frontend-only mock login)
export const ACCOUNT = {
  email: "demo@barlow.lu",
  password: "demo1234",
  name: "Maximilian Bauer",
  refNo: "BC-4827-LU",
  deposits: [
    { id: 1, amount: 100000, months: 60, rate: 4.25, start: "2023-06-01", maturity: "2028-06-01" },
    { id: 2, amount: 50000, months: 24, rate: 3.6, start: "2024-09-15", maturity: "2026-09-15" },
    { id: 3, amount: 25000, months: 12, rate: 3.3, start: "2025-02-01", maturity: "2026-02-01" },
  ],
};
